module.exports = __webpack_public_path__ + "img/Advanced Search - Pink - Selected.e62fb88c.png";